
<template>
  <div>
    <div class="k-article k-card k-article-subscribe">
      <div class="k-subscribe__loading-wrapper" v-if="isLoading">
        <k-spinner />
      </div>
      <div class="k-article__image-wrapper" style="position: relative;">
        <div class="k-image__overblock">
          <img v-if="getCurrentStaticData.image" class="k-article__img" :src="getCurrentStaticData.image" :key="getCurrentStaticData.image" />
        </div>
        <div class="k-article__footer-always d-block">
          <div :class="['d-flex', 'flex-wrap', {'justify-content-end': special || !bought}, {'justify-content-between': !special && !bought}]">
            <div class="k-article__info-button" v-if="!special">1 300 - 1 600 ККАЛ</div>
            <template v-if="!getCurrentStaticData.notForSale">
            <div
                v-if="(!bought && isMobile && getCurrentStaticData.lock && getCurrentStaticData.buyLink) || (isMobile && getCurrentStaticData.free && getCurrentStaticData.buyLink)"
                @click="open(getCurrentStaticData.buyLink)"
                class="k-article__buy-button"
            >Купить</div>
            <div
                v-if="!bought && isMobile"
                @click="buy"
                class="k-article__buy-button"
            >{{ getCurrentButtonText }}</div>
            </template>
          </div>
          <div class="k-article__nav-buttons" v-if="false">
            <div class="k-article__nav-button k-article__nav-button-left">
              <svg
                class="k-article__nav-button-img"
                width="5"
                height="8"
                viewBox="0 0 5 8"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4.87569 7.33123L1.11878 4L4.87569 0.66877C5.04144 0.51735 5.04144 0.264984 4.87569 0.113565C4.70994 -0.0378549 4.4337 -0.0378549 4.21271 0.113565L0.124309 3.69716C-0.0414365 3.84858 -0.0414365 4.10095 0.124309 4.25237L4.15746 7.88644C4.3232 8.03786 4.59945 8.03786 4.82044 7.88644C5.04144 7.73502 5.04144 7.48265 4.87569 7.33123Z"
                  fill="white"
                />
              </svg>
            </div>
            <div v-if="isShowArrows" class="k-article__nav-button k-article__nav-button-right">
              <svg
                class="k-article__nav-button-img"
                width="5"
                height="8"
                viewBox="0 0 5 8"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.124309 0.668769L3.88122 4L0.12431 7.33123C-0.0414358 7.48265 -0.0414357 7.73502 0.12431 7.88644C0.290056 8.03786 0.566299 8.03786 0.787293 7.88644L4.87569 4.30284C5.04144 4.15142 5.04144 3.89905 4.87569 3.74763L0.842541 0.113564C0.676795 -0.0378548 0.400553 -0.0378547 0.179558 0.113564C-0.0414364 0.264984 -0.0414364 0.51735 0.124309 0.668769Z"
                  fill="white"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>
      <div class="k-article__content d-flex">
        <div style="width: 100%;">
          <div class="k-article__title-wrapper">
            <div class="k-article__title">{{ getCurrentStaticData.title }}</div>
            <div class="k-article__badges" v-if="getCurrentStaticData.tags">
              <span class="k-badge badge k-badge-yellow mr-1">{{ getCurrentStaticData.tags[0] }}</span>
              <span class="k-badge badge k-badge-red mr-1">{{ getCurrentStaticData.tags[1] }}</span>
              <span class="k-badge badge k-badge-green">{{ getCurrentStaticData.tags[2] }}</span>
            </div>
          </div>
          <div class="description-detail">
            <div class="k-article__description">
              <p v-html="getCurrentStaticData.description"></p>
              <!-- {{ getCurrentStaticData.description }} -->
            </div>
            <div class="k-article__detail mb-1" @click="show()" v-if="!showMore && !getCurrentStaticData.nohide">
              <span v-if="getExpires && $route.name === 'UserSubscribes'" class="k-article__expires-mobile">До {{ dateFormat(getExpires, 'dd.mm.yyyy') }}</span>
              <span v-else></span>
              <span>
                <span class="mr-2">Подробнее</span>
                <svg style="transform: rotate(-90deg)" width="7" height="13" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.77624 14.6625L2.01381 8L8.77624 1.33754C9.07458 1.0347 9.07458 0.529969 8.77624 0.227129C8.4779 -0.0757098 7.98066 -0.0757098 7.58287 0.227129L0.223757 7.39432C-0.0745856 7.69716 -0.0745856 8.20189 0.223757 8.50473L7.48343 15.7729C7.78177 16.0757 8.27901 16.0757 8.6768 15.7729C9.07458 15.47 9.07458 14.9653 8.77624 14.6625Z" fill="#FFCC1B"></path></svg>
              </span>
              <!-- <img src="../assets/Arrow1.svg" style="margin: 5px;"> -->
            </div>
          </div>
          <div :class="{'k-article__badges':true, 'mobile': true, 'detail': showMore}" v-if="getCurrentStaticData.tags">
            <span class="k-badge badge k-badge-yellow mr-1">{{ getCurrentStaticData.tags[0] }}</span>
            <span class="k-badge badge k-badge-red mr-1">{{ getCurrentStaticData.tags[1] }}</span>
            <span class="k-badge badge k-badge-green">{{ getCurrentStaticData.tags[2] }}</span>
          </div>
          <div
              :class="{'k-article__body': true, 'mb-2': true, 'detail': showMore}"
              v-if="getCurrentStaticData.lists && getCurrentStaticData.lists.length"
              style="flex-wrap: wrap; opacity: 0.64;"
          >

            <div
                v-for="(list, i) of getCurrentStaticData.lists"
                :key="`subscribe-list-${i}`"
                :class="{'col-6': !showMore}"
            >
              <span class="k-article__body-subtitle text-uppercase">
                {{ list.title }}
              </span>
              <ul class="k-article__body-list">
                <li
                    v-for="item in list.list"
                    :key="item"
                    class="k-article__body-list-item"
                >
                  <span>{{ item }}</span>
                </li>
              </ul>
            </div>
            <!-- <div class="k-article__nav-buttons" v-if="!single" style="align-self: flex-end;">
              <div class="k-article__nav-button k-article__nav-button-left cursor-pointer" @click="$emit('prevSubscribe')">
                <svg
                  class="k-article__nav-button-img"
                  width="5"
                  height="8"
                  viewBox="0 0 5 8"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M4.87569 7.33123L1.11878 4L4.87569 0.66877C5.04144 0.51735 5.04144 0.264984 4.87569 0.113565C4.70994 -0.0378549 4.4337 -0.0378549 4.21271 0.113565L0.124309 3.69716C-0.0414365 3.84858 -0.0414365 4.10095 0.124309 4.25237L4.15746 7.88644C4.3232 8.03786 4.59945 8.03786 4.82044 7.88644C5.04144 7.73502 5.04144 7.48265 4.87569 7.33123Z"
                    fill="white"
                  />
                </svg>
              </div>
              <div v-if="isShowArrows" class="k-article__nav-button k-article__nav-button-right cursor-pointer" @click="$emit('nextSubscribe')">
                <svg
                  class="k-article__nav-button-img"
                  width="5"
                  height="8"
                  viewBox="0 0 5 8"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0.124309 0.668769L3.88122 4L0.12431 7.33123C-0.0414358 7.48265 -0.0414357 7.73502 0.12431 7.88644C0.290056 8.03786 0.566299 8.03786 0.787293 7.88644L4.87569 4.30284C5.04144 4.15142 5.04144 3.89905 4.87569 3.74763L0.842541 0.113564C0.676795 -0.0378548 0.400553 -0.0378547 0.179558 0.113564C-0.0414364 0.264984 -0.0414364 0.51735 0.124309 0.668769Z"
                    fill="white"
                  />
                </svg>
              </div>
            </div> -->
          </div>
          <span class="k-article__expires-desktop" v-if="getExpires && $route.name === 'UserSubscribes'">До {{ dateFormat(getExpires, 'dd.mm.yyyy') }}</span>
          <div :class="{'k-article__body': true, 'mb-2': true, 'detail': showMore || getCurrentStaticData.nohide}" v-if="getCurrentStaticData.short_description">
            <span v-html="getCurrentStaticData.short_description"></span>
          </div>
          <div
              class="w-fluid d-flex justify-content-lg-between align-items-center"
              :class="{'flex-wrap': !isMobile, 'mt-1': isMobile}"
          >
            <div
                v-if="getCurrentStaticData.footer"
                v-html="getCurrentStaticData.footer"
                class="desktop-description-warning d-none d-md-block"
                style="padding-bottom: 5px;"
            ></div>
            <template v-if="!getCurrentStaticData.notForSale">
            <div
                v-if="(!bought && !isMobile && getCurrentStaticData.lock && getCurrentStaticData.buyLink) || (!isMobile && getCurrentStaticData.free && getCurrentStaticData.buyLink)"
                @click="open(getCurrentStaticData.buyLink)"
                class="k-article__buy-button k-article__buy-button--default"
            >Купить</div>
            <div
                v-if="!bought && !isMobile"
                @click="buy"
                class="k-article__buy-button k-article__buy-button--default"
            >{{ getCurrentButtonText }}</div>
            </template>
            <div
                v-if="!bought && getCurrentStaticData.howUnblockLink"
                @click="open(getCurrentStaticData.howUnblockLink)"
                class="k-article__buy-button k-article__buy-button_how-unblock"
            >Как разблокировать</div>
            <template v-if="getCurrentStaticData.buttonLinks">
              <template v-for="buttonLink of getCurrentStaticData.buttonLinks">
                <div
                    v-if="(buttonLink.mustBeBought && bought) || (buttonLink.mustBeNoBought && !bought) || (!buttonLink.mustBeBought && !buttonLink.mustBeNoBought)"
                    :key="`buttonLink-${buttonLink.name}`"
                    @click="open(buttonLink.link)"
                    class="k-article__buy-button"
                >{{ buttonLink.name }}</div>
              </template>
            </template>
          </div>
        </div>
        <div class="d-flex" style="margin-left: 15px;">
          <div class="k-article__nav-buttons" v-if="!single" style="align-self: center;">
            <div v-if="isShowArrows" class=" k-article__nav-button-right cursor-pointer" @click="$emit('nextSubscribe')">
              <img src="../assets/ExpandMore2.svg" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import KSpinner from './TheSpinner.vue';
import dateFormat from '../utils/dateformat';

export default {
  data() {
    return {
      showMore: false,
      dateFormat,
    }
  },
  components: {
    KSpinner,
  },
  props: {
    isLoading: Boolean,
    bought: {
      type: Boolean,
      default: true,
    },
    special: Boolean,
    title: {
      type: String,
    },
    menuId: {
      type: String,
      default: '',
    },
    single: {
      type: Boolean,
      default: false,
    },
    price: {
      type: Number,
    },
    isShowArrows: {
      type: Boolean,
      required: false,
      default: true
    },
  },
  methods: {
    buy() {
      if (this.special) {
        this.$root.$emit('buy-subscription-special', this.menuId, this.getCurrentStaticData.lock, this.getCurrentStaticData.free);
      } else {
        this.$root.$emit('buy-subscribe', this.menuId);
      }
    },
    show() {
      this.$emit('show-more', this.menuId);
    },
    open(link) {
      window.open(link, '_blank')
    },
  },
  computed: {
    ...mapGetters([
      'getSubscribesAndSets',
      'getAvaiableUserSets',
      'getAvaiableUserSubscribes',
      'getUserSubscribes'
    ]),
    isMobile() {
      return this.$mq === 'sm' || this.$mq === 'xs';
    },
    getCurrentStaticData() {
      return this.getSubscribesAndSets.find(el => el.id === this.menuId) || this.getSubscribesAndSets[0]
    },
    getCurrentRealData() {
      const current = this.getAvaiableUserSets.concat(this.getAvaiableUserSubscribes);
      const subscribe = current.find(el => el.id === this.menuId);
      return subscribe || {}
    },
    getExpires() {
      return this.getCurrentRealData.id === '21ffc672-02ca-411b-b210-97351f996512' &&
        this.getUserSubscribes.find(el => el.menu_id === '21ffc672-02ca-411b-b210-97351f996512')?.finished_at
    },
    getCurrentButtonText() {
      if (this.special && !this.getCurrentStaticData.lock && !this.getCurrentStaticData.lock && !this.getCurrentStaticData.free) return `Купить за ${this.getCurrentRealData.price} рублей`
      else if (this.getCurrentStaticData.lock) return 'Разблокировать'
      else if (this.getCurrentStaticData.free) return 'Бесплатно'
      else return 'Купить'
    }
  },
}
</script>

<style lang="scss" scoped>
.k-article {
  @media (max-width: 576px) {
    margin: 0 15px;
  }
  &__title {
    @media (min-width: 576px) {
      text-transform: uppercase;
    }
  }
  &__description{
    @media (max-width: 576px) {
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      overflow: hidden;
      // height: fit-content;
      max-height: 60px;
    }

  }
  &-subscribe {
    position: relative;
  }
  &__body {
    &-list {
      margin-top: 5px;
    }
    &.spec {
      background: #F68C1E;
      border-radius: 4px;
      padding: 5px 20px;
      span {
        p {
            color: #FFFFFF;
        }
         font-style: normal;
            font-weight: normal;
            font-size: 16px;
            line-height: 23px;
            color: #FFFFFF;
        .subscribe__short-text--title {

            font-style: normal;
            font-weight: normal;
            font-size: 16px;
            line-height: 23px;
          }
            // &--default {
            //   font-weight: normal;
            //   font-size: 12px;
            //   line-height: 16px;
            //   letter-spacing: -0.5px;
            //   color: #FFFFFF;
            // }

      }
    }
  }
  &__footer-always {
    position: absolute;
    bottom: 0;
    width: 100%;
    padding: 10px;
  }
  &__detail {
    display: none;
    @media (max-width: 575.98px) {
      display: flex;
      width: 100%;
      justify-content: space-between;
      cursor: pointer;
      align-items: flex-end;
      margin: 10px 0 0;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 19px;
      color: #000000;
      opacity: 0.64;
    }
  }
  &__expires-desktop {
    display: none;
    @media (min-width: 575.98px) {
      display: inline;
      padding: 3px 10px;
      color: #fff;
      font-size: 16px;
      background: #F68C1E;
      border-radius: 6px;
    }
  }
  &__expires-mobile {
    display: none;
    @media (max-width: 575.98px) {
      display: flex;
      padding: 3px 10px;
      color: #fff;
      font-size: 16px;
      background: #F68C1E;
      border-radius: 6px;
    }
  }
  &__badges {
    @media (max-width: 575.98px) {
      margin: 10px 0;
    }
  }
}
.k-subscribe__loading-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #fff;
  opacity: 0.85;
  display: flex;
  justify-content: center;
  align-content: center;
  z-index: 3;
}
.mobile {
  display: none;
}
.detail {
  @media (max-width: 575.98px) {
    display: flex;
    flex-wrap: wrap;
  }
}
.description-detail {
  margin-top: 10px;
  @media (max-width: 575.98px) {
    display: flex;
    justify-content: flex-end;
    flex-wrap: wrap;
    max-height: 90px;
    margin-top: 0;
    // justify-content: space-between;
    .k-article__description {
      width: 100%;
      // width: 65%;
      // max-height: 35px;
      // text-overflow: ellipsis;
      // white-space: nowrap;
      // overflow: hidden;
      // display: -webkit-box;
      // -webkit-line-clamp: 2;
      // -webkit-box-orient: vertical;
      // overflow: hidden;
    }
  }
}
.k-article__buy-button {
  margin: 2px;
}
.k-article__buy-button_how-unblock {
  padding-top: 0;
  padding-bottom: 0;
  max-width: 150px;
}
</style>
